import React from 'react';
// Componentes de la calculadora: src/components/sections/Calculadora
import { PRODUCTS } from '../Calculadora/products';
import ProductThumb from '../Calculadora/ProductThumb';
import '../Calculadora/MaterialCalculator.css'; // estilos de .dc-thumb

const RUTA_CALCULADORA = '/calculadora-materiales';

const pasos = [
  { titulo: 'Mide tu espacio', texto: 'Captura largo y ancho, o escribe directamente los m² de tu proyecto.' },
  { titulo: 'Elige el producto', texto: 'Selecciona el piso o recubrimiento que quieres cotizar.' },
  { titulo: 'Recibe tu estimado', texto: 'Obtén la cantidad estimada de material y cotiza por WhatsApp.' },
];

// Cuántos productos se muestran en la grilla decorativa (usa PRODUCTS.length para mostrarlos todos)
const MAX_PRODUCTOS = 9;

const CalculadoraHome = () => {
  const productos = PRODUCTS.slice(0, MAX_PRODUCTOS);

  return (
    <section id="calculadora" className="dt-calc dt-section">
      <div className="container">
        <div className="dt-calc__wrap">
          <div className="wow fadeInUp" data-wow-delay="200ms">
            <span className="dt-eyebrow">Calculadora de materiales</span>
            <h2 className="h1 mb-0">Calcula cuánto material necesitas antes de cotizar</h2>
            <p className="dt-calc__lead">
              Una forma rápida de saber qué cantidad de producto comprar para tu piso o muro.
            </p>

            <ol className="dt-calc__steps">
              {pasos.map((p) => (
                <li key={p.titulo}>
                  <div>
                    <strong>{p.titulo}</strong>
                    <span>{p.texto}</span>
                  </div>
                </li>
              ))}
            </ol>

            <a className="butn-style3" href={RUTA_CALCULADORA}>Ir a la calculadora</a>
          </div>

          <div className="wow fadeInUp" data-wow-delay="350ms">
            <p className="dt-calc__label">Productos que puedes calcular</p>
            <div className="dt-calc__marquee">
              <ul className="dt-calc__products">
                {productos.map((p) => (
                  <li key={p.id} className="dt-prod">
                    <ProductThumb product={p} />
                    <div className="dt-prod__name">{p.name}</div>
                  </li>
                ))}
                {/* Copia para el bucle continuo del carrusel móvil (oculta en escritorio) */}
                {productos.map((p) => (
                  <li key={`clone-${p.id}`} className="dt-prod dt-prod--clone" aria-hidden="true">
                    <ProductThumb product={p} />
                    <div className="dt-prod__name">{p.name}</div>
                  </li>
                ))}
              </ul>
            </div>

            <p className="dt-calc__note" role="note">
              <i className="fas fa-box-open" aria-hidden="true"></i>
              <span>
                <strong>Solo venta de producto.</strong> No incluye instalación; consulta con tu contratista de confianza.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalculadoraHome;